import { render, staticRenderFns } from "./StageAssignmentOpened.vue?vue&type=template&id=98bf5878&scoped=true&"
import script from "./StageAssignmentOpened.vue?vue&type=script&lang=ts&"
export * from "./StageAssignmentOpened.vue?vue&type=script&lang=ts&"
import style0 from "./StageAssignmentOpened.vue?vue&type=style&index=0&id=98bf5878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bf5878",
  null
  
)

export default component.exports